import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class QuotesService {

    constructor(private http: HttpClient) { }
    getPaymentType() {
        return this.http.get(environment.url + 'payment_type');
    }
    getBank() {
        return this.http.get(environment.url + 'bank');
    }
    getSupplierComparison(id: any) {
        return this.http.get(environment.url + 'supplier-comparisons/maintenance-request/' + id);
    }
    approveOrDenyComparison(payload: any) {
        return this.http.post(environment.url + 'supplier-comparisons/approve-or-deny', payload);
    }
    addSupplier(payload: any) {
        // Detect if there are evidence files inside suppliers
        const suppliers: any[] = payload?.suppliers || [];
        const hasFiles = suppliers.some((s) => {
            const ev = s?.evidences;
            return Array.isArray(ev) && ev.some((f) => f instanceof File);
        });

        if (!hasFiles) {
            // No files present: send as JSON
            return this.http.post(environment.url + 'suppliers/add', payload);
        }

        // Build FormData: Laravel expects suppliers[0][evidences][0] for files
        const fd = new FormData();
        if (payload?.type !== undefined) fd.append('type', String(payload.type));
        if (payload?.maintenance_request_id !== undefined) {
            fd.append('maintenance_request_id', String(payload.maintenance_request_id));
        }

        // Clone suppliers without File objects for JSON stringification
        const suppliersWithoutFiles = suppliers.map((s) => {
            const { evidences, ...rest } = s || {};
            return rest;
        });
        fd.append('suppliers', JSON.stringify(suppliersWithoutFiles));

        // Append each evidence file using indexed keys so Laravel maps to suppliers.0.evidences.0
        suppliers.forEach((s, i) => {
            const ev: any[] = Array.isArray(s?.evidences) ? s.evidences : [];
            ev.forEach((file, j) => {
                if (file instanceof File) {
                    fd.append(`suppliers[${i}][evidences][${j}]`, file, file.name);
                }
            });
        });

        return this.http.post(environment.url + 'suppliers/add', fd);
    }

    getSuppliers(query: string){
        return this.http.get(`${environment.url}suppliers/autocomplete?q=${query}`)
    }
}
